import React from "react";
import Card from "../../components/Common/Card";
import TitleHeader from "../../components/Common/TitleHeader";
import { BlogContainer } from "../../helpers/StyledComponents";
import { styled } from "styled-components";
import { Button } from "antd";

const ThreeCards = () => {
  const currentDomain = `${window.location.protocol}//${window.location.hostname}`;
  const handleOnClick = (e) => {
    window.location.href = "all-activities";
  };
  return (
    <>
      <TitleHeader
        en="RECENT NEWS & ACTIVITIES"
        th="ข่าวสารและกิจกรรมล่าสุด"
        center
      />
      <BlogContainer maxWidth="1000" style={{ margin: "0px auto" }}>
        <CardContainer>
          <Card
            title="SU Bible Day Camp #10 พลัง 1-2เปโตร “ยืนหยัดทำสิ่งถูกต้อง”"
            image="https://i.ibb.co/7xktN3Td/thumbnail-image0.png"
            detailLink={`${currentDomain}/activities?actNo=11`}
          />
          <Card
            title="Certificate for Sunday School Teaching 2025"
            image="https://i.ibb.co/PsVNywyB/sunday-school.png"
            detailLink={`${currentDomain}/activities?actNo=8`}
          />
          <Card
            title="กิจกรรม SU Thailand 2025"
            image="https://i.ibb.co/tPBgd3JS/SU-THAILAND-2025-1.png"
            detailLink={`${currentDomain}/activities?actNo=5`}
          />
        </CardContainer>
      </BlogContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "20px auto",
        }}
      >
        <Button
          type="primary"
          shape="round"
          size="large"
          onClick={handleOnClick}
          style={{ fontWeight: "bold" }}
        >
          <div>กิจกรรมทั้งหมด</div>
        </Button>
      </div>
    </>
  );
};

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export default ThreeCards;
